/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { CommentReply, List } from "./data-contracts";

/**
 * No description
 * @tags space-comment
 * @name ListCommentRepliesInSpace
 * @summary List all space comment replies
 * @request GET:/spaces/{spaceId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const listCommentRepliesInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: CommentReply[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/comments/{commentId}/replies",
  method: "get",
  streaming: false,
  tags: ["space-comment"],
  criticalityLevel: "low",
  deprecated: false,
};
